import { ControlledSelect } from "@dune/ui";
import {
	brokerContactCreationSubRoles,
	brokerUserCreationSubRolesLabels,
} from "@dune/vars";
import { useFormContext } from "react-hook-form";
import { useGetAllBrokersSocieties } from "../../api/queries/societies.queries";
import { AddOrUpdateContactFormModeProps } from "./ContactForm";
import { ContactFormData } from "./useAddContactForm";

export const BrokerContactForm = ({
	mode,
}: AddOrUpdateContactFormModeProps) => {
	const formMethods = useFormContext<ContactFormData>();
	const {
		control,
		formState: { errors },
	} = formMethods;

	const { data: brokerSocieties } = useGetAllBrokersSocieties({});

	return (
		<>
			<ControlledSelect
				options={brokerSocieties?.data?.map((brokerSociety) => ({
					label: brokerSociety.denomination,
					value: brokerSociety.id,
				}))}
				label="Rattacher à un apporteur existant"
				name="brokerSocietyId"
				control={control}
				placeholder="Sélectionner"
				error={errors.brokerSocietyId?.message}
				required
				disabled={mode === "update"}
			/>
			<ControlledSelect
				options={brokerContactCreationSubRoles.map((subrole) => ({
					label: brokerUserCreationSubRolesLabels[subrole],
					value: subrole,
				}))}
				label="Rôle"
				name="brokerSubRole"
				control={control}
				placeholder="Sélectionner"
				error={errors.brokerSubRole?.message}
				required
			/>
		</>
	);
};
